import { ListItem, Stack, Typography, Avatar, Box } from '@mui/material';
import {
  IMessage,
  IReferralsOrBenefits,
  markNotificationAsVisited,
  markReferralsOrBenefitsAsVisited,
} from 'API';
import { format } from 'date-fns';
import { useImposter, useIsDesktop } from 'Hooks';
import { NotificationBlueCircle } from 'Images';
import { useNavigate } from 'react-router-dom';

import { instanceOfIMessage } from 'Utils/instanceOfIMessage';

interface IProps {
  message: IMessage | IReferralsOrBenefits;
}

export const Update = ({ message }: IProps) => {
  const navigate = useNavigate();

  const isDesktop = useIsDesktop();

  const { fakeUser, authenticatedUser, imposterId } = useImposter();

  const getCaseNumber = () => {
    let caseNumber: string = '';

    if (imposterId) {
      caseNumber = fakeUser?.caseNumber || '';
    } else {
      caseNumber = authenticatedUser?.caseNumber || '';
    }

    return caseNumber;
  };

  return (
    <ListItem
      sx={{
        paddingX: '0',
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          width: '100%',
          boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
          borderRadius: '16px',
          p: '24px',
          background: '#FFF',
        }}
        onClick={async () => {
          message.isVisited = true;
          if (instanceOfIMessage(message)) {
            await markNotificationAsVisited({
              itemId: message.itemId,
              typeId: message.notifciationTypeId,
            });
            navigate(message.linkUrl);
          } else {
            const caseNumber = getCaseNumber();
            await markReferralsOrBenefitsAsVisited(
              caseNumber,
              message.notifciationTypeId
            );
            window.location.href = message.linkUrl;
          }
        }}
      >
        {!message.isVisited && (
          <Avatar
            src={NotificationBlueCircle}
            sx={{
              position: 'absolute',
              top: '-6px',
              left: '-13px',
            }}
            alt=''
          />
        )}
        <Stack>
          {instanceOfIMessage(message) && (
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '24px',
                color: '#60727E',
              }}
            >
              {format(new Date(message.date), 'dd/MM/yyyy')}
            </Typography>
          )}
          {message.title && (
            <Typography
              variant='h3'
              sx={{
                fontWeight: 700,
                lineHeight: '16px',
                mt: 1,
                mb: isDesktop ? '16px' : '12px',
              }}
            >
              {message.title}
            </Typography>
          )}
          {message.description && (
            <Typography fontSize='18px' lineHeight={'22px'}>
              {message.description}
            </Typography>
          )}
          {instanceOfIMessage(message) && message.linkText && (
            <Typography
              fontSize='18px'
              sx={{
                lineHeight: '22px',
                color: '#1752AF',
                textDecorationLine: 'underline',
              }}
            >
              {message.linkText}
            </Typography>
          )}
        </Stack>
      </Box>
    </ListItem>
  );
};
